import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconVideo(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs />
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={78.28}
          x2={21.72}
          y1={78.15}
          y2={21.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <linearGradient
          id={`${iconUuid}_b`}
          x1={60.69}
          x2={28.69}
          y1={65.87}
          y2={33.87}
          xlinkHref={`#${iconUuid}_a`}
        />
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M50 9.87a40 40 0 1040 40 40 40 0 00-40-40zm0 78.5a38.5 38.5 0 1138.5-38.5A38.54 38.54 0 0150 88.37z"
      />
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M33.9 71.08l42.79-21.21L33.9 28.66zm1.5-40l37.91 18.79L35.4 68.66z"
      />
    </svg>
  );
}
export default SvgEchIconVideo;
